var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimpleShred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "com_cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1792v1080h-1792z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.c_s0 { fill: #bebebe }\n\t\t.c_s1 { fill: #ebebeb }\n\t\t.c_s2 { fill: #ffffff }\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-workspace-task-simple-shred",
    clipPath: "url(#com_cp1)",
    transform: "translate(-457 -315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 14258",
    className: "c_s0",
    d: "m488.5 339h-31.5v13.7c0 1.2 0.9 2.1 2.1 2.1h27.3c1.2 0 2.1-0.9 2.1-2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14259",
    className: "c_s0",
    d: "m488.5 326.4v12.6h-31.5v-22c0-1.2 0.9-2.1 2.1-2.1h17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14260",
    className: "c_s1",
    d: "m477 314.9v9.4c0 1.2 0.9 2.1 2.1 2.1h9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14261",
    className: "c_s2",
    d: "m464.8 328.4h3.1v3h-3.1zm6.1 0h3.1v3.1h-3.1zm6.1 0h3.1v3h-3.1zm-12.2 6.1h3.1v3.1h-3.1zm6.1 0h3.1v3h-3.1zm6.1 0h3.1v3.1h-3.1zm-12.2 6.1h3.1v3h-3.1zm6.1 0h3.1v3.1h-3.1zm6.1 0h3.1v3h-3.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleShred);
export default __webpack_public_path__ + "static/media/simple-shred.bb01e8d6f3a32ab450f24742ef8af5b5.svg";
export { ForwardRef as ReactComponent };